module.exports = "pegasus_template/assets/tech/basic_3/1.png";